export default __webpack_public_path__ + "static/media/candy.f62741d6.svg";